<template>
    <div class="txt-item">
        <v-row class="mx-n8px my-0">
            <v-col v-if="this.$slots['title']" cols="12" md="auto" class="px-8px py-0">
                <p :class="'txt txt--xl txt--dark font-weight-medium '+ titleClass"><slot name="title" /></p>
            </v-col>
            <v-col v-if="this.$slots['default']" cols="12" md="" class="px-8px py-0">
                <p class="txt txt--xl"><slot /></p>
            </v-col>
        </v-row>
    </div>
</template>

<script>
export default {
    props: {
        title: { type: String },
        titleClass: { type: String },
    },
    components: {},
    data: () => {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped>
.txt-item {
    & + & {
        margin-top: 12px;
    }
}
@media (min-width: 576px) {
}
@media (min-width: 768px) {
    .txt-item {
        & + & {
            margin-top: 6px;
        }
    }
}
@media (min-width: 1024px) {
}
@media (min-width: 1200px) {
}
</style>
